import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { FidelidadeEmail } from '../models/fidelidade-email';

@Injectable({
  providedIn: 'root'
})
export class FidelidadeEmailService {

  constructor(private http: HttpClient) {

  }

  consultar() {
    return this.http.get<FidelidadeEmail[]>(globals.apiUrl + '/api/FidelidadeEmail/Lista');
  }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);
    return this.http.get<any>(globals.apiUrl + '/api/FidelidadeEmail/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id) {
    return this.http.get<FidelidadeEmail>(globals.apiUrl + '/api/FidelidadeEmail/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(fidelidadeEmail: FidelidadeEmail) {
    return this.http.post(globals.apiUrl + '/api/FidelidadeEmail/Salvar', fidelidadeEmail);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/FidelidadeEmail/Excluir',
      { params: new HttpParams().set('id', id) });
  }

}
